<script setup lang="ts">
import { HomeBlogCard } from '#components';
import type { BlogArticle } from '#shared/blog/types';

defineProps<{
  blogArticles: Array<BlogArticle>
}>();
</script>

<template>
  <div class="bg-neutral-80 py-2xl">
    <IadWrapper>
      <IadTitle
        :text="$t('homepage.latest_articles')"
        variant="large"
        class="py-s md:py-m"
        tag="p"
      />
      <div class="grid grid-cols-1 md:grid-cols-3 gap-s md:gap-m">
        <HomeBlogCard
          v-for="article of blogArticles"
          :key="article.link"
          class="last:hidden md:last:flex"
          :article
        />
      </div>
    </IadWrapper>
  </div>
</template>
